import { __awaiter, __assign, __generator } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useCallback, useEffect, useContext } from 'react';
import { getApps } from '../services/app.service.js';

var appContext = createContext(null);
var AppProvider = function (_a) {
    var platformId = _a.platformId, authApiBaseUrl = _a.authApiBaseUrl, customApps = _a.customApps, children = _a.children;
    var _b = useState(), apps = _b[0], setApps = _b[1];
    var getApplications = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (customApps) {
                        setApps(customApps);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, getApps(authApiBaseUrl)];
                case 1:
                    data = _a.sent();
                    setApps(data);
                    return [2 /*return*/];
            }
        });
    }); }, [authApiBaseUrl, customApps]);
    useEffect(function () {
        getApplications();
    }, [getApplications]);
    return (jsx(appContext.Provider, __assign({ value: { platformId: platformId, apps: apps, reload: getApplications } }, { children: children }), void 0));
};
var useAppContext = function () {
    var context = useContext(appContext);
    if (!context) {
        throw new Error("useAppContext must be used within a AppProvider");
    }
    return context;
};

export { AppProvider as default, useAppContext };
